export default __webpack_public_path__ + "static/media/jobshub-04-v1.31a3a2b4.jpg";